import { ENV } from '@autopass-web/domain';

import { DIST } from './config';

const environment = ENV === 'production' ? 'production' : 'alpha';

export const sentryConfig = {
  dsn: 'https://35d64ddbcc36cf1e7cb2248e8ac865a5@o121681.ingest.us.sentry.io/4507186139693056',
  authToken:
    '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',
  environment: `${environment} ${DIST}`,
};
